import { Component } from "@theme/component";
import { requestIdleCallback } from "@theme/utilities";

/**
 * Hides the "Read more" toggle when the product description fits within the preview lines.
 *
 * @extends {Component}
 */
class ProductDescAccordion extends Component {
  connectedCallback() {
    super.connectedCallback();
    requestIdleCallback(() => this.#checkOverflow());
  }

  /**
   * Expands or collapses the description preview.
   */
  toggle() {
    const button = this.querySelector(".product-desc-accordion__label--toggle");
    if (!(button instanceof HTMLButtonElement)) return;

    const expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", expanded ? "false" : "true");
  }

  /**
   * If content doesn't overflow the preview height, add class to hide the toggle.
   */
  #checkOverflow() {
    const button = this.querySelector(".product-desc-accordion__label--toggle");
    if (button?.getAttribute("aria-expanded") === "true") return;

    const textEl = this.querySelector(".product-desc-accordion__text");
    const label = button;
    if (!textEl || !label) return;

    const style = window.getComputedStyle(textEl);
    const maxHeight = parseFloat(style.maxHeight);
    if (!maxHeight || maxHeight > 500) return;

    const inner = textEl.querySelector(".product-desc-accordion__text-inner");
    const origMaxHeight = textEl.style.maxHeight;
    const origLineClamp = inner ? inner.style.webkitLineClamp : "";
    const origDisplay = inner ? inner.style.display : "";

    textEl.style.maxHeight = "none";
    if (inner) {
      inner.style.webkitLineClamp = "unset";
      inner.style.display = "block";
    }

    const naturalHeight = textEl.scrollHeight;

    textEl.style.maxHeight = origMaxHeight || "";
    if (inner) {
      inner.style.webkitLineClamp = origLineClamp || "";
      inner.style.display = origDisplay || "";
    }

    if (naturalHeight <= maxHeight + 2) {
      this.classList.add("product-desc-accordion--no-overflow");
    }
  }
}

if (!customElements.get("product-desc-accordion")) {
  customElements.define("product-desc-accordion", ProductDescAccordion);
}

export default ProductDescAccordion;
